<template>
	<div class="row mt-4 mb-5">
		<div class="col-2"></div>
		<div class="col-8">
			<div role="group">
				<label for="password_confirmref" class="fw-500">{{$t('login_confirm_password')}}</label>
				<b-form-input
					:type="typePass"
					id="password_confirmref"
					v-model="password_confirm"
					:placeholder="$t('login_confirm_new_password')"
					class="fw-500"
					trim
				></b-form-input>
			</div>
			<div class="icon-lock-login">&nbsp;</div>
			<div class="eyeOpen pointer" @click="showPass()">
				<i v-if="typePass=='password'" class="icon-view-black"></i>
				<i v-else class="icon-stop-view-black"></i>
			</div>
		</div>
		<div class="col-2"></div>
	</div>
</template>

<script>
import loginControl from '@/mixins/Login/loginControl';

export default {
	name: 'InputConfirmPassword',

	mixins: [
		loginControl
	],

	data (){
		return {
			password_confirm: null,
			typePass: 'password',
		}
	},

	watch: {
		password_confirm(){
			this.$emit('update:updateConfirmPassword', {
				password_confirm: this.password_confirm
			});
		},
	},
}
</script>

<style lang="scss" scoped>
	// Não mostrar o olho do Edge no input
	::-ms-reveal {
		display: none;
	}
</style>